import { HttpClient, RequestParams } from "@/utils/http-client";

export enum SkillAreaLevelType {
  Value1 = 1,
  Value2 = 2,
}

export interface SkillAreaType {
  child_skill_areas?: SkillAreaType[];
  has_children?: boolean;
  id?: number;
  level?: SkillAreaLevelType;
  name?: string;
  parent_id?: number;
}

export interface FindSkillAreasParamsType {
  level?: number;
}

export class SkillArea<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description Search function for searching skill areas
   *
   * @tags skillAreas
   * @name FindSkillAreas
   * @summary Search function for searching skill areas
   * @request GET:/skill_area
   * @response `200` `(SkillAreaType)[]` Skill areas results
   * @response `500` `void` error
   */
  findSkillAreas = (
    query: FindSkillAreasParamsType,
    params: RequestParams = {}
  ) =>
    this.request<SkillAreaType[], void>({
      path: `/skill_area`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
}
